<template>
  <section class="next grid">
    <a
      href="#!"
      class="next__inner container--small"
      @click="(e) => {
        e.preventDefault();
        $store.commit('NEXT_TYPE', 'default');
        $router.push(`/esposizione/${data.id}`);
      }"
    >
      <p data-anim="fade" data-trans="next">Next</p>
      <div class="next__title" data-trans="next">
        <h1 data-anim="title">
          {{ data.brand }} <span>. {{ data.name }}</span>
        </h1>
      </div>
      <div
        class="next__img"
      >
        <img :src="data.image" :alt="data.name">
        <div class="next__filler" style="opacity: 0;"></div>
      </div>
    </a>
  </section>
</template>

<script>
export default {
  name: 'Next',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.next {
  &__title {
    position: relative;
    overflow: hidden;

    h1 {
      margin: 0;

      display: inline-block;
      position: relative;
      white-space: nowrap;

      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 12%;

        background: RGB($color-text);

        transform: scaleX(0);
        transform-origin: 0% 50%;
        transition: all 0.4s ease-out;
      }
    }
  }

  &__inner {
    display: block;
    text-align: center;

    padding: rem(100px) 0;

    p {
      margin-top: 0 0 rem(30px) 0;
    }

    &:hover {
      h1::before {
        transform: scaleX(1.01);
      }

      .next__img {
        img {
          opacity: 1;
          transform: translateY(200px) rotate(2deg);
        }
      }
    }
  }

  &__img {
    position: absolute;
    bottom: 0;
    left: -25%;
    width: 150%;
    height: 100%;

    opacity: 0.7;

    img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
      transform: translateY(400px) rotate(-5deg);
      opacity: 0;
      transition: all 0.4s cubic-bezier(.165,.84,.44,1);
    }

    pointer-events: none;
    z-index: -1;
  }

  &__filler {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    pointer-events: none;

    background: RGB($color-bg);
    mix-blend-mode: multiply;

    @at-root body[data-theme="day"] & {
      mix-blend-mode: unset;

      @media (prefers-color-scheme: dark) {
        mix-blend-mode: multiply;
      }
    }

    /* @media (prefers-color-scheme: light) {
      mix-blend-mode: unset;
    } */
  }
}
</style>
